import angular from 'angular';
import { config } from './associate.services.config';
import AssociateServices from './associate.services.component';
export default angular.module('invision.customercare.customer.associateServices', []).config(config).component('associateServices', AssociateServices).name;